// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reference Compounds overrides - left-align ID, SMILES, Actions */
.subtable-wrapper .p-datatable-tbody > tr > td:first-child,
.subtable-wrapper .p-datatable-tbody > tr > td:nth-child(3),
.subtable-wrapper .p-datatable-tbody > tr > td:last-child {
  text-align: left !important;
}

/* Center body cells for Structure and custom columns (matching Design page) */
.project-compounds-table .p-datatable-tbody > tr > td:nth-child(2),
.project-componds-table .p-datatable-tbody > tr > td:nth-child(n+4):nth-child(-n+10) {
  text-align: center !important;
  vertical-align: middle !important;
}

/* Force center alignment for Structure column and custom columns */
.ref-center-cell {
  text-align: center !important;
}

.ref-center-cell .p-datatable-tbody > tr > td {
  text-align: center !important;
}
`, "",{"version":3,"sources":["webpack://./src/scene-pm/Projects/ProjectView/ReferenceCompounds/ReferenceCompounds.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;;;EAGE,2BAA2B;AAC7B;;AAEA,8EAA8E;AAC9E;;EAEE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA,mEAAmE;AACnE;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":["/* Reference Compounds overrides - left-align ID, SMILES, Actions */\n.subtable-wrapper .p-datatable-tbody > tr > td:first-child,\n.subtable-wrapper .p-datatable-tbody > tr > td:nth-child(3),\n.subtable-wrapper .p-datatable-tbody > tr > td:last-child {\n  text-align: left !important;\n}\n\n/* Center body cells for Structure and custom columns (matching Design page) */\n.project-compounds-table .p-datatable-tbody > tr > td:nth-child(2),\n.project-componds-table .p-datatable-tbody > tr > td:nth-child(n+4):nth-child(-n+10) {\n  text-align: center !important;\n  vertical-align: middle !important;\n}\n\n/* Force center alignment for Structure column and custom columns */\n.ref-center-cell {\n  text-align: center !important;\n}\n\n.ref-center-cell .p-datatable-tbody > tr > td {\n  text-align: center !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
